
export const API_VERSION = 'v1';
export const API_URL = `${typeof process !== 'undefined' ? process.env.API_URL : `/api`}/${API_VERSION}`;

const YC_MOCK_FIGMA_LINK = 'YC_DEMO';

export const FIGMA_PLUGIN_URL = 'https://www.figma.com/community/plugin/1550515809572066859/figma-to-deck-ai';

